export default __webpack_public_path__ + "static/Qatarblack-56fdf0ff4ff9a53e8ee103e39345ec6f.webp";